import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './stores'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import axios from 'axios';
const app = createApp(App);
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
app.config.globalProperties.$axios = axios;
// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
  
  app.use(router).use(store).use(createPinia()).use(ElementPlus).mount('#app');
